import { render, staticRenderFns } from "./SustainedTurnFields.vue?vue&type=template&id=181678cb&"
import script from "./SustainedTurnFields.vue?vue&type=script&lang=ts&"
export * from "./SustainedTurnFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SustainedTurnFields.vue"
export default component.exports